import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import InvoiceCreateModalUI from './InvoiceCreateModalUI.js'

class InvoiceCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      successMsg: null,
      errorList: null,
      // create invoice
      submitted: false,
      // invoice name
      invoiceName: '',
      invoiceNameError: null,
    }
  }

  render() {
    return (
      <InvoiceCreateModalUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        // create mode
        createMode={this.props.createMode}
        // invoice name
        invoiceName={this.state.invoiceName}
        onInvoiceNameChange={(event) => {this.setState({invoiceName: event.target.value})}}
        invoiceNameError={this.state.invoiceNameError}
        setInvoiceNameError={(error) => {this.setState({invoiceNameError: error})}}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
        onCancelClick={this.onCancelClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/orders/${this.props.match.params.orderId}/invoices`,
      this.onSubmitCallback, {
        invoiceName: this.state.invoiceName,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch(error.fieldName) {
        case 'invoiceName':
          this.setState({invoiceNameError: error.message})
          break;
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (this.state.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
      }, 2000)
      this.props.onCreateComplete(response.invoice)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  onCancelClick = () => {
    // reset everything
    this.setState({
      successMsg: null,
      errorList: null,
      invoiceName: '',
      invoiceNameError: null,
      submitted: false
    })
    this.props.onCancelClick()
  }

  getMessages(context) {
    let arr = [
      'c_create_invoice',
      'c_create',
      'c_cancel',
      'c_invoice_name',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('inv_crt', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(InvoiceCreateModalSF)
